/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- CARD PLACEMENT : STYLES --------------- ++++++++++ */
export default theme => ({
    cardplacement: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: pxToEm(20),
        '& .singleselectdropdown': {
            width: pxToEm(85),
            height: 'auto',
            marginLeft: pxToEm(10),
            '& .placeholder': {
                height: pxToEm(32),
                padding: `0 ${pxToEm(18)}`
            },
            '& .name-menuItems': {
                position: 'absolute',
                minWidth: `${pxToEm(85)} !important`
            }
        },
        '& .field': {
            maxWidth: pxToEm(85),
            marginLeft: pxToEm(10),
            '& .formelement': {
                height: pxToEm(32)
            }
        }
    }
});
